<template>
  <tr class="opportunity-list-item">
    <td>{{ opportunity.id }}</td>
    <td>{{ opportunity.name | nullable }}</td>
    <td>{{ opportunity.appearance_type | sentenceCase | nullable }}</td>
    <td>{{ opportunity.field_set | sentenceCase | nullable }}</td>
    <td>{{ opportunity.optional_fields | parseArray | sentenceCase | nullable }}</td>
    <td>
      <template v-if="valueType === 'points'">
        {{ opportunity.points + 'pts' | nullable }}
      </template>
      <template v-else-if="valueType === 'budget'">
        {{ moneySymbol + opportunity.budget | nullable }}
      </template>
      <template v-else>
        {{ null | nullable }}
      </template>
    </td>
    <td>{{ opportunity.category ? opportunity.category.name : null | nullable }}</td>
    <td>
      <toggle-button
        v-model="opportunity.active"
        :labels="{ checked: 'YES', unchecked: 'NO' }"
        :color="{ checked: $brandPrimary, unchecked: '#b7b7b7' }"
        @change="({ value, srcEvent }) => toggleActiveStatus(value)"/>
    </td>
    <td>
      <button class="edit-button" @click="$emit('edit', opportunity.id)">
        <i class="fa fa-fw fa-pencil-square-o" />
      </button>
    </td>
  </tr>
</template>

<script>
import { http } from 'utils'
import getSymbolFromCurrency from 'currency-symbol-map'
export default {
  props: {
    opportunity: {
      required: true,
      type: Object
    }
  },

  methods: {
    toggleActiveStatus (value) {
      this.opportunity.active = value
      http.put(`opportunities/${this.opportunity.id}/active`, { active: value })
    }
  },

  filters: {
    parseArray: function (value) {
      if (Array.isArray(value)) {
        return value.join()
      }
      return value
    }
  },

  computed: {
    moneySymbol () {
      if (this.opportunity.category && this.opportunity.category.currency) {
        const currency = this.opportunity.category.currency
        if (currency === 'points') {
          return 'Pts'
        }
        return getSymbolFromCurrency(currency)
      }
      return ''
    },
    valueType () {
      // no category but budget is there
      if (!this.opportunity.category && this.opportunity.budget) {
        return 'budget'
      }

      // category present and value based on category
      if (this.opportunity.category && this.opportunity.category.currency === 'points' && this.opportunity.points) {
        return 'points'
      }

      // category present and value based on category
      if (this.opportunity.category && this.opportunity.category.currency !== 'points' && this.opportunity.budget) {
        if (!this.opportunity.category.currency) {
          return 'none'
        }
        return 'budget'
      }

      return 'none'
    }
  }
}
</script>
